import { Expose } from 'class-transformer'
import type { PersonNoteResource as Model } from '@/services/api/client'
import type { CamelCaseKeys } from '@/types/utility'

export type SerializedPersonNoteResource = Model

export default class PersonNoteResource implements CamelCaseKeys<SerializedPersonNoteResource> {
    id: Model['id']

    notes!: Model['notes']

    @Expose({ name: 'is_private' })
    isPrivate?: Model['is_private']

    @Expose({ name: 'created_on' })
    createdOn?: Model['created_on']

    user?: Model['user']

    @Expose({ name: 'person_id' })
    personId?: Model['person_id']

    constructor(values: PersonNoteResource) {
        Object.assign(this, values)
    }
}
